const CATEGORY_LISTING_PAGE_CONSTANTS = {
  SET_PAGINATED_PLP_LOADING: 'SET_PAGINATED_PLP_LOADING',
  SET_CATEGORY_LOADED_PAGINATED_PRODUCTS: 'SET_CATEGORY_LOADED_PAGINATED_PRODUCTS',
  SET_PAGINATED_CONSOLIDATED_RES_DATA: 'SET_PAGINATED_CONSOLIDATED_RES_DATA',
  FETCH_INITIAL_PRODUCTS_WITH_FACETS: 'FETCH_INITIAL_PRODUCTS_WITH_FACETS',
  FETCH_PAGINATED_PRODUCTS: 'FETCH_PAGINATED_PRODUCTS',
  SET_CURRENT_NAV_IDS: 'SET_CURRENT_NAV_IDS',
  SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
  SET_CATEGORY_LOADED_PRODUCTS: 'SET_CATEGORY_LOADED_PRODUCTS',
  SET_BOPIS_FILTER_STATE: 'SET_BOPIS_FILTER_STATE',
  RESET_PAGINATED_PRODUCTS: 'RESET_PAGINATED_PRODUCTS',
  RESET_CACHED_AT: 'RESET_CACHED_AT',
  LOAD_CATEGORY_PAGE_SEO_DATA: 'LOAD_CATEGORY_PAGE_SEO_DATA',
  SET_CATEGORY_PAGE_SEO_DATA: 'SET_CATEGORY_PAGE_SEO_DATA',
  FETCH_INITIAL_CATEGORY: 'FETCH_INITIAL_CATEGORY',
  SET_HORIZONTAL_PLP_FLAG: 'SET_HORIZONTAL_PLP_FLAG',
  PICK_UP_IN_STORE: 'PICK UP IN STORE',
  ADD_TO_BAG: 'ADD TO BAG',
  SET_CATEGORY_PAGE_PDP_LINK_CLICKED: 'SET_CATEGORY_PAGE_PDP_LINK_CLICKED',
  SET_PENDING_ADD_WISHLIST_PRODUCT: 'SET_PENDING_ADD_WISHLIST_PRODUCT',
  SET_SERVICE_ERROR_FLAG: 'SET_SERVICE_ERROR_FLAG',
  SET_ALTERNATE_PLP_FLAG: 'SET_ALTERNATE_PLP_FLAG',
  SET_PAGINATED_ALTERNATE_PLP_FLAG: 'SET_PAGINATED_ALTERNATE_PLP_FLAG',
  UPDATE_APPLIED_FILTERS: 'UPDATE_APPLIED_FILTERS',
  SET_FROM_HPLP: 'SET_FROM_HPLP_FLAG',
  RESET_SEO_HEADER_COPY_LOADED_FLAG: 'RESET_SEO_HEADER_COPY_LOADED_FLAG',
  SET_PRODUCT_LOADING_FLAG: 'SET_PRODUCT_LOADING_FLAG',
  GET_SEO_TOKEN_JSON: 'GET_SEO_TOKEN_JSON',
  SET_PLP_SEO_TOKEN_LIST: 'SET_PLP_SEO_TOKEN_LIST',
  UPDATE_FILTERS_FROM_URL: 'UPDATE_FILTERS_FROM_URL',
  SET_STAGE_HOLD_CATEGORY: 'SET_STAGE_HOLD_CATEGORY',
  SET_CATEGORY_MODULE_FILTERS: 'SET_CATEGORY_MODULE_FILTERS',
  SET_PRICE_FILTER_FLAG: 'SET_PRICE_FILTER_FLAG',
  SET_QUICK_FILTER: 'SET_QUICK_FILTER',
};

export default CATEGORY_LISTING_PAGE_CONSTANTS;
